import { isStringIndexable } from 'app/constants/schemas/utils';
import { decodeOrThrow } from 'app/utils/ioTs';
import { fromJS, Map } from 'immutable';
import * as t from 'io-ts';

export { Map };

interface IMapMarshaller {
  deserialize: (mapData: unknown) => Map<string, unknown>;
  serialize: (map: Map<string, unknown>) => unknown;
}

export const MapType = new t.Type<Map<string, unknown>, unknown, unknown>(
  'MapType',
  (m: unknown): m is Map<string, unknown> => m instanceof Map && isStringIndexable(m),
  (m, c) => {
    if (m === undefined || isStringIndexable(m)) {
      return t.success(fromJS(m) as Map<string, unknown>);
    } else {
      return t.failure(m, c);
    }
  },
  (m: Map<string, unknown>) => m.toJS(),
);

// This is kind of a fallback for meta data. It would be better to use structured
// data in place of this, when possible.
export const MapMarshaller: IMapMarshaller = {
  deserialize: (mapData): Map<string, unknown> => {
    return decodeOrThrow(MapType, mapData, (errors) => {
      throw new Error(errors.join('\n'));
    });
  },
  serialize: MapType.encode,
};
